<template>
<div class="chapter">
<div class="inner_page">
<p class="copy1"><a id="page_iv">Copyright © 2016 Fordham University Press</a></p><a id="page_iv">
<p class="copy1">All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means—electronic, mechanical, photocopy, recording, or any other—except for brief quotations in printed reviews, without the prior permission of the publisher.</p>
<p class="copy1">Fordham University Press has no responsibility for the persistence or accuracy of URLs for external or third-party Internet websites referred to in this publication and does not guarantee that any content on such websites is, or will remain, accurate or appropriate.</p>
<p class="copy1">Fordham University Press also publishes its books in a variety of electronic formats. Some content that appears in print may not be available in electronic books.</p>
</a><p class="copy1"><a id="page_iv">Visit us online at </a><a href="http://www.fordhampress.com" target="_blank">www.fordhampress.com</a>.</p>
<p class="copy1">Library of Congress Cataloging-in-Publication Data</p>
<p class="copy1">Names: Bean, Christopher B.</p>
<p class="copyh">Title: Too great a burden to bear : the struggle and failure of the Freedmen’s Bureau in Texas / Christopher B. Bean.</p>
<p class="copyh">Description: First edition. | New York : Fordham University Press, 2016. | Series: Reconstructing America | Includes bibliographical references and index.</p>
<p class="copyh">Identifiers: LCCN 2015042262 (print) | LCCN 2016006934 (ebook) | ISBN 9780823268757 (cloth : alkaline paper) | ISBN 9780823271764 (paper : alkaline paper) | ISBN 9780823268764 (ePub)</p>
<p class="copyh">Subjects: LCSH: African Americans—Texas—History—19th century. | Freedmen—Texas—History. | Reconstruction (U.S. history, 1865–1877)—Texas. | United States. Bureau of Refugees, Freedmen, and Abandoned Lands—Officials and employees—Biography. | United States. Bureau of Refugees, Freedmen, and Abandoned Lands—History. | Texas—Race relations—History—19th century. | BISAC: HISTORY / United States / Civil War Period (1850–1877). | SOCIAL SCIENCE / Ethnic Studies / African American Studies.</p>
<p class="copyh">Classification: LCC E185.93.T4 B43 2016 (print) | LCC E185.93.T4 (ebook) | DDC 305.896/073076409034—dc23</p>
<p class="copyh">LC record available at <a href="http://lccn.loc.gov/2015042262" target="_blank">http://lccn.loc.gov/2015042262</a></p>
<p class="copy1">First edition</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?666b95f4